import { render, staticRenderFns } from "./casting_component.vue?vue&type=template&id=75bdf28c"
import script from "./casting_component.vue?vue&type=script&lang=js"
export * from "./casting_component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports